import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import { caisse } from "components/app/RemExpertIntialState";
import TextField from "components/ui/controls/text-field/text-field";
import DropDown from "components/ui/controls/drop-down/drop-down";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import ParamCarpv from "components/app/AuditComplet/SituationPro/ParamCaisse/ParamCarpv";
import ParamCavec from "components/app/AuditComplet/SituationPro/ParamCaisse/ParamCavec";
import ParamLpaPageModal from "pages/audit complet/situation professionnelle/modules/parametre lpa modal";


function DonneesAdministratives(props) {
  const context = useContext(AppContext);

  return (
    <>
      <Column fill>
        <Row>
          <Column fill>

      
        <CardBox className="card-box">
          <Column fill>
            <div className="dossier-header">
              <div className="dossier-header-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m-3-2.757l.879.508 1.378.31 2.486 1.4a.75.75 0 001.378-.608l.158-1.066c.055-.379.308-.733.696-.920l1.035-.497c.421-.203.421-.79 0-.993l-1.035-.497c-.388-.187-.641-.541-.696-.920l-.158-1.066a.75.75 0 00-1.378-.608L12 8.757l-2.486-1.4a.75.75 0 00-1.378.608l-.158 1.066c-.055.379-.308.733-.696.92l-1.035.497c-.421.203-.421.79 0-.993l1.035.497c.388.187.641.541.696.92l.158 1.066c0 .316.178.602.467.748L12 13.757z" />
                </svg>
              </div>
              <h3 className="dossier-header-title">Rémunération de {context.state.Prenom}</h3>
            </div>
            <Row>
              <Column>
                <DropDown label="Caisse d'affiliation" value={context.state.Caisse} options={caisse} onChange={context.handleChoixCaisse} normal />
              </Column>
            </Row>

            {context.state.Caisse === "Carpv" && <ParamCarpv Outil="" ClientConjoint="" />}
            {context.state.Caisse === "Cavec" && <ParamCavec Outil="" ClientConjoint="" />}
            {context.state.Caisse === "Cnbf" && (
              <>
                <Row>
                  <Column>
                    <ParamLpaPageModal Outil="" ClientConjoint="" />
                  </Column>
                </Row>
              </>
            )}
            <Row>
              <Column>
                <TextField
                  label="Revenus annuels nets"
                  value={context.state.Remuneration}
                  onChange={context.handleInputChange("Remuneration")}
                  dataType="uint"
                  format={{ thousands: " ", unit: " €" }}
                  normal
                />
              </Column>
            </Row>
          </Column>
        </CardBox>

        </Column>
        </Row>
      </Column>
      
    </>
  );
}

export default DonneesAdministratives;
